import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const DisplayContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  margin: '5px 0',
  padding: theme.spacing(1.25),
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.shape.borderRadius,
  width: '100%',
  boxSizing: 'border-box',
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1.875),
  textAlign: 'center',
}));

export const DocumentContent = styled('pre')(({ theme }) => ({
  textWrap: 'balance',
  whiteSpace: 'pre-wrap',
  overflow: 'auto',
  maxHeight: 'fit-content',
  fontFamily: 'Poppins',
  fontSize: '1rem',
  '& h1': {
    fontSize: '1.5rem',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1.875),
    textAlign: 'center',
  },
  '& h2': {
    fontSize: '1.3rem',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1.875),
    textAlign: 'center',
  },
  '& h3': {
    fontSize: '1rem',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1.875),
    textAlign: 'center',
  },
}));